import { useState, useCallback, useEffect } from 'react';
import { useGoalsVsActual } from './useGoalsVsActual';

// O backend pode devolver um objeto em erros de validação; renderizar objeto
// como filho quebra o React, então coagimos para texto antes de exibir.
const toErrorText = (data) =>
  typeof data === 'string' && data ? data : 'Não foi possível carregar as metas.';

// Orquestra a aba de metas. Consumido pelas versões web e mobile, que ficam
// responsáveis apenas pela apresentação.
export function useGoalsTabScreen(period) {
  const { comparison, totalIncomes, hasGoals, isLoading, error, refetch } =
    useGoalsVsActual(period);

  const [isGoalsModalOpen, setGoalsModalOpen] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (error) {
      setShowErrorMessage(true);
      setErrorMessage(toErrorText(error));
    }
  }, [error]);

  const openGoalsModal = useCallback(() => setGoalsModalOpen(true), []);
  const closeGoalsModal = useCallback(() => setGoalsModalOpen(false), []);

  const handleGoalsSaved = useCallback(() => {
    setGoalsModalOpen(false);
    refetch();
  }, [refetch]);

  return {
    comparison,
    totalIncomes,
    hasGoals,
    isLoading,
    showErrorMessage,
    setShowErrorMessage,
    errorMessage,
    isGoalsModalOpen,
    openGoalsModal,
    closeGoalsModal,
    handleGoalsSaved,
  };
}
